// Phase 7.5 D3 — Track C T-C2. Insights copy.
//
// Strings for the new /insights route plus the daily-deck AI-summary +
// intelligence-affordances cards. Phrasing follows blueprint §13.4:
// calm, factual, declarative, no exclamation marks, no emoji.

export const insightsCopy = {
  navLabel: 'Insights',
  pageTitle: 'Insights',
  pageSubtitle: 'Weekly AI summaries and spend analytics for your account.',

  latestInsightTitle: 'Latest insight',
  generatedPrefix: 'Generated',
  emptyListTitle: 'No insights yet',
  emptyListBody:
    'DailyDeck will write a weekly insight every Monday — your first one will land within seven days of activity.',

  thisMonthTitle: 'This month',
  totalLabel: 'Total spend',
  vsLastMonthLabel: 'vs last month',
  biggestChangesLabel: 'Biggest changes',
  topCategoriesLabel: 'Top categories',

  emptySpendTitle: 'No transactions in this period yet',
  emptySpendBody:
    'Connect Gmail or upload a statement to start tracking spend.',
  emptySpendCtaPrimary: 'Connect Gmail',
  emptySpendCtaSecondary: 'Open payments',

  loadingLabel: 'Loading insights',
  errorTitle: 'Could not load insights',
  errorBody: 'Try again in a moment.',
  errorRetry: 'Retry',

  // Daily-deck AI-summary section.
  dailyDeck: {
    aiSummaryTitle: "Today's AI summary",
    aiSummaryEmptyBody: 'DailyDeck writes a weekly summary every Monday.',
    aiSummaryEmptyCta: 'Open insights',

    affordancesTitle: 'Intelligence',
    // Q-3 OVERRIDE: when all three counts are zero, the card stays visible
    // with this single calm line. Hiding the card on a fresh account would
    // perpetuate the "I do not see the intelligence layer" complaint that
    // opened Phase 7.5.
    affordancesAllZeroBody:
      'Nothing in review, no recurrences detected, no anomalies — the system is quiet.',
    affordancesReviewLabel: 'Predictions waiting in review',
    affordancesRecurringLabel: 'Detected recurrences',
    affordancesAnomaliesLabel: 'Anomalies this period',
  },
} as const;
